<template>
	<div>
		<section
			id="banner_desktop"
			class="section-hero section-shaped my-0 d-none d-sm-block"
			style="
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center center;
				cursor:pointer
			"
			@click="irRegistro()"
			:style="{
				backgroundImage: 'url(' + require('@/assets/img/banners/banner.jpg') + ')',
			}"
		>
			<div class="shape"></div>
			<div class="container-fluid contenedor">
				<div>&nbsp;</div>
				<div class="textoFlotante">
					<h1 style="font-size: 400%" class="text-white texto1">
						<b>Mobil</b><sup style="font-size: 65%">™</sup
						><b> te lleva a la gran carrera</b>
					</h1>
					<h5 style="font-size: 220%" class="text-white texto2">
						Gana un boleto doble y Vive la experiencia.
					</h5>
				</div>
				<!-- <div id="registrar">
                <a href="#register"><img src="https://mobilracing.mx/img/boton registrar.png" alt="" width=""></a>
            </div> -->
			</div>
		</section>
		<section class="section-hero section-shaped d-block d-sm-none my-0" @click="irRegistro()" style="cursor:pointer">
			<!-- <div class="shapechico "> -->
			<img
				:src="require('@/assets/img/banners/banner_movil.jpg')"
				alt=""
				class="img-fluid"
				style="width: 100% !important"
			/>
			<!-- </div> -->
		</section>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isMobile: this.$mobile(),
		};
	},
	methods: {
		irRegistro() {
			// this.$scrollTo('#app');
			this.$emit('scrollRegistro')
		}
	}
};
</script>
<style>
.shape {
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-position: 0% 85%;
	background-size: cover;
	width: 100% !important;
}
.shapechico {
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-position: 0% 85%;
	background-size: cover;
	width: 100% !important;
}
#registrar {
	width: 240px !important;
	margin-left: 29.5% !important;
	/* margin-top: 0.3%; */
	cursor: pointer;
}
#registrar,
img {
	width: 270px !important;
}
.textoFlotante {
	margin-left: 5% !important;
	margin-top: 2% !important;
}
/* X-Small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
	.texto1 {
		font-size: 16px !important;
	}
	.texto2 {
		font-size: 9px !important;
	}
	.textoFlotante {
		margin-top: 10% !important;
	}
	#registrar,
	img {
		width: 135px !important;
	}
}

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
	.texto1 {
		font-size: 16px !important;
	}
	.texto2 {
		font-size: 9px !important;
	}
	.textoFlotante {
		margin-top: 10% !important;
	}
	#registrar,
	img {
		width: 135px !important;
	}
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
	.texto1 {
		font-size: 16px !important;
	}
	.texto2 {
		font-size: 9px !important;
	}
}

/* Large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
}

/* X-Large devices (large desktops, less than 1400px) */
@media (max-width: 1399.98px) {
}
</style>
